import { dateComponents } from "@circle-react/helpers/dateTimeHelpers/dateComponents";
import { Typography } from "@circleco/compass/components/Typography";

export interface EventDateBadgeProps {
  dateString: string;
  timeZone?: string;
}

export const EventDateBadge = ({
  dateString,
  timeZone,
}: EventDateBadgeProps) => {
  const { dayOfMonth, shortMonthString } = dateComponents(dateString, timeZone);

  return (
    <div className="border-primary bg-primary flex size-11 shrink-0 flex-col items-center justify-center rounded-md border shadow-sm">
      <Typography variant="heading-sm" color="primary" component="span">
        {dayOfMonth}
      </Typography>
      <span className="text-tertiary text-[10px] font-bold capitalize leading-tight">
        {shortMonthString}
      </span>
    </div>
  );
};
